// Dawn's modal components, with date-product-picker-modal.
const DATE_CONSTANTS = {
  ordinals: [
    "firsts",
    "seconds",
    "thirds",
    "fourths",
    "fifths",
    "sixths",
    "sevenths",
    "eighths",
    "ninths",
    "tenths",
    "elevenths",
    "twelfths",
    "thirteenths",
    "fourteenths",
    "fifteenths",
    "sixteenths",
    "seventeenths",
    "eighteenths",
    "nineteenths",
    "twentieths",
    "twenty-firsts",
    "twenty-seconds",
    "twenty-thirds",
    "twenty-fourths",
    "twenty-fifths",
    "twenty-sixths",
    "twenty-sevenths",
    "twenty-eighths",
    "twenty-ninths",
    "thirtieths",
    "thirty-firsts",
  ],

  daysByMonth: {
    january: 31,
    february: 29,
    march: 31,
    april: 30,
    may: 31,
    june: 30,
    july: 31,
    august: 31,
    september: 30,
    october: 31,
    november: 30,
    december: 31,
  },
};
function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
    )
  ).filter(
    (el) =>
      el.getAttribute("tabindex") !== "-1" &&
      el.offsetParent !== null &&
      (el.tagName.toLowerCase() === "summary" ||
        !el.closest("details:not([open])"))
  );
}

let trapFocusCounter = 1;
document.querySelectorAll('[id^="Details-"] summary').forEach((summary) => {
  summary.setAttribute("role", "button");
  summary.setAttribute(
    "aria-expanded",
    summary.parentNode.hasAttribute("open")
  );

  if (summary.nextElementSibling.getAttribute("id")) {
    summary.setAttribute("aria-controls", summary.nextElementSibling.id);
  }

  summary.addEventListener("click", (event) => {
    event.currentTarget.setAttribute(
      "aria-expanded",
      !event.currentTarget.closest("details").hasAttribute("open")
    );
  });

  if (summary.closest("header-drawer, menu-drawer")) return;
  summary.parentElement.addEventListener("keyup", onKeyUpEscape);
});

const trapFocusState = {
  history: {},
};
const trapFocusHandlers = {};

function trapFocus(
  container,
  elementToFocus = container,
  autoFocus = true,
  restoreHistoryId
) {
  trapFocusCounter++;

  const stolenFocusId = removeTrapFocus(null, false);
  if (!restoreHistoryId) {
    trapFocusState.history[trapFocusCounter] = {
      container,
      elementToFocus,
      restoreHistoryId: stolenFocusId,
    };
  }

  trapFocusHandlers.focusin = (event) => {
    const elements = getFocusableElements(container);
    const first = elements[0];
    const last = elements[elements.length - 1];
    if (
      event.target !== container &&
      event.target !== last &&
      event.target !== first
    ) {
      return;
    }
    document.addEventListener("keydown", trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function (event) {
    document.removeEventListener("keydown", trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function (event) {
    if (event.code.toUpperCase() !== "TAB") return; // If not TAB key
    const elements = getFocusableElements(container);
    const first = elements[0];
    const last = elements[elements.length - 1];
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }
    //  On the first focusable element and tab backward, focus the last element.
    if (
      (event.target === container || event.target === first) &&
      event.shiftKey
    ) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener("focusout", trapFocusHandlers.focusout);
  document.addEventListener("focusin", trapFocusHandlers.focusin);

  const focusId = restoreHistoryId || trapFocusCounter;
  trapFocusState.current = focusId;
  trapFocusState.container = container;
  trapFocusState.elementToFocus = elementToFocus;

  if (autoFocus) {
    elementToFocus.focus();
  }

  if (
    elementToFocus.tagName === "INPUT" &&
    ["search", "text", "email", "url"].includes(elementToFocus.type) &&
    elementToFocus.value
  ) {
    elementToFocus.setSelectionRange(0, elementToFocus.value.length);
  }

  return focusId;
}

function focusInTrap(focusId) {
  if (trapFocusState.current === focusId && trapFocusState.elementToFocus) {
    trapFocusState.elementToFocus.focus();
  }
}

// Here run the querySelector to figure out if the browser supports :focus-visible or not and run code based on it.
try {
  document.querySelector(":focus-visible");
} catch (e) {
  focusVisiblePolyfill();
}

function focusVisiblePolyfill() {
  const navKeys = [
    "ARROWUP",
    "ARROWDOWN",
    "ARROWLEFT",
    "ARROWRIGHT",
    "TAB",
    "ENTER",
    "SPACE",
    "ESCAPE",
    "HOME",
    "END",
    "PAGEUP",
    "PAGEDOWN",
  ];
  let currentFocusedElement = null;
  let mouseClick = null;

  window.addEventListener("keydown", (event) => {
    if (navKeys.includes(event.code.toUpperCase())) {
      mouseClick = false;
    }
  });

  window.addEventListener("mousedown", (event) => {
    mouseClick = true;
  });

  window.addEventListener(
    "focus",
    () => {
      if (currentFocusedElement)
        currentFocusedElement.classList.remove("focused");

      if (mouseClick) return;

      currentFocusedElement = document.activeElement;
      currentFocusedElement.classList.add("focused");
    },
    true
  );
}

function removeTrapFocus(elementToFocus = null, restoreTrap = true) {
  document.removeEventListener("focusin", trapFocusHandlers.focusin);
  document.removeEventListener("focusout", trapFocusHandlers.focusout);
  document.removeEventListener("keydown", trapFocusHandlers.keydown);

  const { current } = trapFocusState;
  const currentTrap = trapFocusState.history[trapFocusState.current];

  trapFocusState.container = null;
  trapFocusState.elementToFocus = null;
  trapFocusState.current = null;

  if (elementToFocus) elementToFocus.focus();

  if (restoreTrap) {
    const previousTrapId = currentTrap && currentTrap.restoreHistoryId;
    if (previousTrapId) {
      const previousTrap = trapFocusState.history[previousTrapId];
      trapFocus(
        previousTrap.container,
        previousTrap.elementToFocus,
        true,
        previousTrapId
      );
    }
  }

  return current;
}

class ModalDialog extends HTMLElement {
  constructor() {
    super();
    const closeButtons = Array.from(
      this.querySelectorAll('[id^="ModalClose-"]')
    );
    closeButtons.forEach((el) =>
      el.addEventListener("click", this.hide.bind(this, false))
    );
    // this.querySelector('[id^="ModalClose-"]').addEventListener(
    //   "click",
    //   this.hide.bind(this, false)
    // );
    this.addEventListener("keyup", (event) => {
      if (event.code.toUpperCase() === "ESCAPE") this.hide();
    });
    if (this.classList.contains("media-modal")) {
      this.addEventListener("pointerup", (event) => {
        if (
          event.pointerType === "mouse" &&
          !event.target.closest("deferred-media, product-model")
        )
          this.hide();
      });
    } else {
      this.addEventListener("click", (event) => {
        if (event.target === this) this.hide();
      });
    }
  }

  connectedCallback() {
    if (this.moved) return;
    this.moved = true;
    document.body.appendChild(this);
  }

  getFocusTarget() {
    return this.querySelector('[role="dialog"]') || this;
  }

  show(opener) {
    this.setAttribute("tabindex", 0);
    this.openedBy = opener;
    const popup = this.querySelector(".template-popup");
    document.body.classList.add("overflow-hidden", "modal-open");
    this.setAttribute("open", "");

    if (popup) popup.loadContent();

    if (window.pauseAllMedia) {
      window.pauseAllMedia();
    }

    const hasAnimation = this.classList.contains("modal--animated");
    let focusTrapId;
    if (hasAnimation) {
      this.addEventListener(
        "transitionend",
        () => {
          focusInTrap(focusTrapId);
        },
        {
          once: true,
        }
      );
    }

    this.classList.add("modal-opening");
    setTimeout(() => {
      focusTrapId = trapFocus(this, this.getFocusTarget(), !hasAnimation);
    });

    publish(PUB_SUB_EVENTS.modalShow, {
      id: this.id,
      openedBy: opener,
      element: this,
    });
  }

  close() {
    this.removeAttribute("tabindex");
    document.body.classList.remove("overflow-hidden", "modal-open");
    document.body.dispatchEvent(new CustomEvent("modalClosed"));
    this.removeAttribute("open");
    removeTrapFocus(this.openedBy);
    if (window.pauseAllMedia) {
      window.pauseAllMedia();
    }

    publish(PUB_SUB_EVENTS.modalHide, {
      id: this.id,
      openedBy: this.openedBy,
      element: this,
    });
  }

  hide() {
    let animationStart;
    this.classList.remove("modal-opening");

    if (!this.classList.contains("modal--animated")) {
      this.close();
      return;
    }

    const handleAnimation = (time) => {
      if (animationStart === undefined) {
        animationStart = time;
      }

      const elapsedTime = time - animationStart;

      if (elapsedTime < 250) {
        window.requestAnimationFrame(handleAnimation);
      } else {
        this.close();
      }
    };

    window.requestAnimationFrame(handleAnimation);
  }
}
customElements.define("modal-dialog", ModalDialog);

class ModalOpener extends HTMLElement {
  constructor() {
    super();

    const button = this.querySelector("button");

    const inMenuDrawer = !!this.closest("menu-drawer");

    if (!button) return;
    button.addEventListener("click", () => {
      const modal = document.querySelector(this.getAttribute("data-modal"));
      if (modal) {
        if (inMenuDrawer) {
          modal.classList.remove("modal--animated");
          setTimeout(function () {
            modal.classList.add("modal--animated");
          });
        }
        modal.show(button);
      }
    });
  }
}
customElements.define("modal-opener", ModalOpener);

class DateProductPickerModal extends ModalDialog {
  constructor() {
    super();

    this.dialog = this.querySelector(".date-product-picker-modal__dialog");
    if (this.dataset.fixedDialog) {
      this.dialog.removeAttribute("aria-modal");
    }

    this.monthsScrollContainer = this.querySelector(
      ".js-months-scroll-container"
    );
    this.daysContainer = this.querySelector(".js-days-container");
    this.monthButtons = Array.from(this.querySelectorAll(".js-month"));

    this.monthButtons.forEach((el) => {
      el.addEventListener("click", this.handleMonthClick.bind(this));
      el.addEventListener("keydown", this.handleDayOrMonthKeyDown.bind(this));
    });
    this.dayButtons = Array.from(this.querySelectorAll(".js-day"));
    this.dayButtons.forEach((el) => {
      el.addEventListener("click", this.handleDayClick.bind(this));
      el.addEventListener("keydown", this.handleDayOrMonthKeyDown.bind(this));
    });
  }

  static getDaysForMonth(month) {
    return DATE_CONSTANTS.daysByMonth[month.toLowerCase()];
  }

  show(opener) {
    this.openedBy = opener;
    this.selectActiveDate();

    super.show(opener);

    this.scrollSelectedMonth();

    this.dialog.setAttribute("aria-modal", "true");
  }

  hide() {
    super.hide();

    if (this.dataset.fixedDialog) {
      this.dialog.removeAttribute("aria-modal");
      this.resetMonths();
    }
  }

  selectActiveDate() {
    if (this.openedBy) {
      if (this.openedBy.dataset.defaultMonth) {
        this.selectedMonth = this.openedBy.dataset.defaultMonth;
        this.selectedDay = this.openedBy.dataset.defaultDay;
      }
    }

    if (this.selectedMonth) {
      const selectedMonthButton = this.monthButtons.find(
        (button) => button.dataset.value === this.selectedMonth
      );
      if (selectedMonthButton) {
        this.setSelectedButton(this.monthButtons, selectedMonthButton);
      }
    }

    this.resetDays(false, true);

    if (this.selectedDay) {
      const selectedDayButton = this.dayButtons.find(
        (button) => button.dataset.value === this.selectedDay
      );
      if (selectedDayButton) {
        this.setSelectedButton(this.dayButtons, selectedDayButton);
      }
    }
  }

  resetMonths() {
    this.selectedMonth = null;
    this.monthButtons.forEach((el, i) => {
      el.setAttribute("tabindex", i === 0 ? 0 : -1);
      el.removeAttribute("aria-selected");
      el.classList.remove("btn--toggle-selected");
    });

    this.resetDays(false, true);
  }

  setSelectedButton(buttonList, selected, animate) {
    const timeUnit = selected.dataset.timeUnit;
    const value = selected.dataset.value;
    if (timeUnit === "month") {
      this.selectedMonth = value;
    } else {
      this.selectedDay = value;
    }

    buttonList.forEach((el) => {
      if (el === selected) {
        el.setAttribute("tabindex", 0);
        el.setAttribute("aria-selected", true);
        el.classList.add("btn--toggle-selected");
      } else {
        el.setAttribute("tabindex", -1);
        el.removeAttribute("aria-selected");
        el.classList.remove("btn--toggle-selected");
      }
    });

    if (timeUnit === "month") {
      this.scrollSelectedMonth(selected, animate);
    }
  }

  scrollSelectedMonth(selected, animate) {
    selected =
      selected ||
      this.monthButtons.find(
        (button) => button.dataset.value === this.selectedMonth
      );

    if (!selected) {
      return;
    }
    if (
      this.monthsScrollContainer.scrollWidth >
      this.monthsScrollContainer.clientWidth
    ) {
      this.monthsScrollContainer.scrollTo({
        left:
          selected.offsetLeft +
          (selected.clientWidth - this.monthsScrollContainer.clientWidth) / 2,
        behavior: animate ? "smooth" : "instant",
      });
    }
  }

  handleMonthClick(e) {
    const monthChanged = e.currentTarget.dataset.value !== this.selectedMonth;

    if (
      !monthChanged &&
      this.dataset.fixedDialog &&
      !this.hasAttribute("open")
    ) {
      this.resetMonths();
    } else {
      this.setSelectedButton(this.monthButtons, e.currentTarget, true);
      this.resetDays(true, monthChanged);
    }
  }

  formatLink(month, day) {
    const urlTemplate =
      (this.openedBy && this.openedBy.dataset.urlTemplate) ||
      this.dataset.urlTemplate;
    const dayOrdinal = DATE_CONSTANTS.ordinals[day - 1];
    return urlTemplate
      .replace("{{ month_capitalized }}", month)
      .replace("{{ month }}", month.toLowerCase())
      .replace("{{ day }}", day)
      .replace("{{ day_ordinal }}", dayOrdinal);
  }

  resetDays(focus = false, clearSelection = false) {
    const month = this.selectedMonth;
    const daysInMonth = this.selectedMonth
      ? DateProductPickerModal.getDaysForMonth(month)
      : 31;
    const defaultDay = 1;
    this.dayButtons.forEach((el) => {
      const dayNumber = parseInt(el.dataset.value);
      if (dayNumber > daysInMonth) {
        el.classList.add("date-product-picker-modal__button--hidden");
        el.href = "#";
        el.setAttribute("tabindex", -1);
        el.setAttribute("aria-hidden", "true");
      } else {
        if (defaultDay === dayNumber) {
          el.setAttribute("tabindex", 0);
          if (focus) {
            el.focus({ focusVisible: true, preventScroll: true });
          }
        } else {
          el.setAttribute("tabindex", -1);
        }
        el.classList.remove("date-product-picker-modal__button--hidden");
        if (month) {
          el.removeAttribute("aria-hidden");
        } else {
          el.setAttribute("aria-hidden", "true");
        }
        el.href = month ? this.formatLink(month, dayNumber) : "#";
      }

      if (clearSelection && el.classList.contains("btn--toggle-selected")) {
        el.removeAttribute("aria-selected");
        el.classList.remove("btn--toggle-selected");
      }
    });

    if (this.selectedMonth) {
      this.daysContainer.removeAttribute("aria-hidden");
    } else {
      this.daysContainer.setAttribute("aria-hidden", true);
    }
  }

  handleDayOrMonthKeyDown(event) {
    let flag = false;

    switch (event.key) {
      case "Right":
      case "ArrowRight":
        this.moveFocusToAdjacentButton(event, 1);
        flag = true;
        break;

      case "Left":
      case "ArrowLeft":
        this.moveFocusToAdjacentButton(event, -1);
        flag = true;
        break;
    }

    if (flag) {
      event.stopPropagation();
      event.preventDefault();
    }
  }

  moveFocusToAdjacentButton(event, offset) {
    const button = event.currentTarget;
    const buttonList = (
      button.dataset.timeUnit === "month" ? this.monthButtons : this.dayButtons
    ).filter((el) => el.getAttribute("aria-hidden") !== "true");

    const currentIndex = buttonList.indexOf(button);

    let nextIndex = currentIndex + offset;
    if (nextIndex < 0) {
      nextIndex = buttonList.length - 1;
    } else if (nextIndex >= buttonList.length) {
      nextIndex = 0;
    }
    const nextButton = buttonList[nextIndex];
    button.setAttribute("tabindex", -1);
    nextButton.setAttribute("tabindex", 0);
    nextButton.focus();
  }

  handleDayClick(event) {
    this.setSelectedButton(this.dayButtons, event.currentTarget);

    if (this.openedBy) {
      const nearestFilterForm = this.openedBy.closest("facet-filters-form");
      if (nearestFilterForm) {
        nearestFilterForm.onFilterClick(event);

        event.stopPropagation();
        event.preventDefault();

        this.hide();
      }
    }
  }
}

customElements.define("date-product-picker-modal", DateProductPickerModal);

subscribe(PUB_SUB_EVENTS.modalShow, ({ element }) => {
  const inputs = document.querySelectorAll(
    'input:not([type="radio"]),textarea,select'
  );
  for (let i = 0; i < inputs.length; i++) {
    const input = inputs[i];
    if (element.contains(input)) {
      continue;
    }
    input.setAttribute("data-input-modified", "true");
    input.setAttribute("data-tab-index", input.getAttribute("tabindex"));
    input.setAttribute("tabindex", -1);
  }
});
subscribe(PUB_SUB_EVENTS.modalHide, ({ element }) => {
  const inputs = document.querySelectorAll('[data-input-modified="true"]');
  for (let i = 0; i < inputs.length; i++) {
    const input = inputs[i];
    if (input.getAttribute("data-tab-index")) {
      input.setAttribute("tabindex", input.getAttribute("data-tab-index"));
      input.removeAttribute("data-tab-index");
    } else {
      input.removeAttribute("tabindex");
    }
    input.removeAttribute("data-input-modified");
  }
});
